module.exports = __webpack_public_path__ + "static/media/lawsociety.deb30781.png";